import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

export interface IPane {
	name: string;
	value: string;
	icon?: React.ReactNode;
	decorator?: string;
	action?: () => void;
}

export const Pane = ({ data }: { data: IPane }) => {
	return (
		<Flex
			justifyContent="center"
			alignItems="center"
			padding="16px 32px"
			borderRight="1px solid #4E4F5299"
			gridGap="32px"
			fontSize="12px"
			lineHeight="1.3em"
			_first={{ paddingLeft: '0' }}
			_last={{ paddingRight: '0', border: 'none' }}
		>
			<Flex
				gridGap="24px"
				alignItems="center"
			>
				{data.icon ?? null}
				<Text
					textTransform="uppercase"
					opacity=".6"
					maxWidth="7em"
				>
					{data.name}
				</Text>
			</Flex>
			<Flex
				fontSize="20px"
				lineHeight="1.4em"
				fontWeight="600"
				alignItems="center"
				justifyContent="flex-end"
				minW="60px"
			>
				<Text color="#ff3f33">{data.decorator}</Text>
				{data.action ? (
					<Text
						onClick={data.action}
						background="hashup"
						fontWeight="500"
						borderRadius="4px"
						textTransform="uppercase"
						cursor="pointer"
						fontSize="12px"
						lineHeight="16px"
						bg="#ff3f33"
						letterSpacing=".1em"
						padding="8px 20px"
					>
						{data.value}
					</Text>
				) : (
					<Text>{data.value}</Text>
				)}
			</Flex>
		</Flex>
	);
};
